window.colors = {"verde y azul":["#3f9e76","#406989"],
                "verde menta":"#73d6b6",
                "verde":"#3f9e76",
                "titanio":"#707b7c",
                "space grey":"#abb2b7",
                "rosa desierto":"#e8aaaa",
                "rosa":"#f4b8d2",
                "rojo":"#b23a48",
                "plata y blanco":["#bfc1c2","#ffffff"],
                "plata":"#bfc1c2",
                "negro y verde":["#2b2b2b","#3f9e76"],
                "negro y rosa":["#2b2b2b","#f4b8d2"],
                "negro y rojo":["#2b2b2b","#b23a48"],
                "negro y plateado":["#2b2b2b","#bfc1c2"],
                "negro y naranja":["#2b2b2b","#e57e31"],
                "negro y morado":["#2b2b2b","#7b5c7e"],
                "negro y gris":["#2b2b2b","#707070"],
                "negro y cobre":["#2b2b2b","#b87333"],
                "negro y blanco":["#2b2b2b","#ffffff"],
                "blanco y negro":["#ffffff","#2b2b2b"],
                "negro y azul":["#2b2b2b","#406989"],
                "negro y amarillo":["#2b2b2b","#e2c747"],
                "cuero":"#2b2b2b",
                "tela":"#a5a5a5",
                "negro y Titanio":["#2b2b2b","#707b7c"],
                "negro business":"#2b2b2b",
                "negro brillante":"#2b2b2b",
                "negro":"#2b2b2b",
                "naranja":"#e57e31",
                "multicolor":["#2b2b2b","#e4e5e7"],
                "morado":"#7b5c7e",
                "walnut":"#8F4E00",
                "walnut y blanco":["#8F4E00","#ffffff"],
                "blanco y walnut":["#ffffff","#8F4E00"],
                "walnut y negro":["#8F4E00","#2b2b2b"],
                "negro y walnut":["#2b2b2b","#8F4E00"],
                "marrón":"#795548",
                "mármol":"#c3bdb8",
                "malva":"#dbb7cd",
                "lima":"#d2db5d", 
                "lila":"#c8a2c8",
                "leopardo":["#e2c747","#2b2b2b"],
                "lavanda":"#b57edc",
                "hielo":"#cdf8f9",
                "gris y verde":["#a5a5a5","#3f9e76"],
                "gris y rosa":["#a5a5a5","#f4b8d2"],
                "gris y blanco":["#a5a5a5","#ffffff"],
                "gris y azul":["#a5a5a5","#406989"],
                "grispálido":"#d1d3d4",
                "gris oscuro":"#4e5054",
                "gris claro":"#d1d3d4",
                "gris":"#a5a5a5",
                "grafito":"#474a4e",
                "fucsia":"#f400a1",
                "dorado":"#d4af37",
                "cyan":"#00ffff",
                "coral":"#ff7f50",
                "color madera":"#a47449",
                "champán":"#f7e7ce",
                "carbonizado":"#36454f",
                "blanco y rojo":["#ffffff","#b23a48"],
                "blanco y verde":["#ffffff","#3f9e76"],
                "blanco hueso":"#e3dac9",
                "blanco":"#ffffff",
                "beige":"#f5f5dc",
                "bambú":"#dda15e",
                "azul y cobre":["#406989","#b87333"],
                "azul marino":"#000080",
                "azul":"#406989",
                "arándano":"#4f86f7",
                "amarillo":"#e2c747",
                "arena":"#decba4",
                "blanco y amarillo":["#ffffff","#e2c747"],
                "verde oscuro":"#355e3b",
                "crema":"#f5f5c6"};
